/* tslint:disable */
/* eslint-disable */
/**
 * Rejeem API
 * Rejeem API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


// May contain unused imports in some cases
// @ts-ignore
import { MultiLangStringDto } from './multi-lang-string-dto';

/**
 * 
 * @export
 * @interface UpdatePlanRequest
 */
export interface UpdatePlanRequest {
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlanRequest
     */
    'active'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlanRequest
     */
    'visible'?: boolean;
    /**
     * 
     * @type {MultiLangStringDto}
     * @memberof UpdatePlanRequest
     */
    'name': MultiLangStringDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    'slug': string;
    /**
     * 
     * @type {MultiLangStringDto}
     * @memberof UpdatePlanRequest
     */
    'summary': MultiLangStringDto;
    /**
     * 
     * @type {MultiLangStringDto}
     * @memberof UpdatePlanRequest
     */
    'description': MultiLangStringDto;
    /**
     * 
     * @type {string}
     * @memberof UpdatePlanRequest
     */
    'imageId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlanRequest
     */
    'ingredientEditable'?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof UpdatePlanRequest
     */
    'portionCustomizable'?: boolean;
    /**
     * 
     * @type {number}
     * @memberof UpdatePlanRequest
     */
    'minDeliveryDaysOfWeek'?: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdatePlanRequest
     */
    'availableDays'?: Array<UpdatePlanRequestAvailableDaysEnum>;
    /**
     * 
     * @type {Set<string>}
     * @memberof UpdatePlanRequest
     */
    'dietTypes'?: Set<UpdatePlanRequestDietTypesEnum>;
}

export const UpdatePlanRequestAvailableDaysEnum = {
    Monday: 'MONDAY',
    Tuesday: 'TUESDAY',
    Wednesday: 'WEDNESDAY',
    Thursday: 'THURSDAY',
    Friday: 'FRIDAY',
    Saturday: 'SATURDAY',
    Sunday: 'SUNDAY'
} as const;

export type UpdatePlanRequestAvailableDaysEnum = typeof UpdatePlanRequestAvailableDaysEnum[keyof typeof UpdatePlanRequestAvailableDaysEnum];
export const UpdatePlanRequestDietTypesEnum = {
    LowCarb: 'LOW_CARB',
    Balanced: 'BALANCED',
    Vegan: 'VEGAN',
    HighProtein: 'HIGH_PROTEIN',
    Keto: 'KETO',
    GlutenFree: 'GLUTEN_FREE'
} as const;

export type UpdatePlanRequestDietTypesEnum = typeof UpdatePlanRequestDietTypesEnum[keyof typeof UpdatePlanRequestDietTypesEnum];


